<template>
  <div id="app">
    <div class="wrapper d-flex flex-column vh-100">
      <div v-if="true" class="headerSection">
        <div class="container">
          <div class="headerCol">
            <div class="d-flex justify-content-between align-items-center">
              <div class="headerLink d-flex justify-content-between align-items-center">
                <ul>
                  <li v-if="!isNotInLogin() && !isNotInHome()">
                    <router-link class="nav-link" to="/farms">
                      <i class="material-icons">arrow_back</i>
                    </router-link>
                    <span class="title align-middle">{{ $t("routes."+routeName) }}</span>
                  </li>
                  <li v-if="isNotInHome()">
                    <router-link class="nav-link" to="/farms">
                      <img src="@/assets/greenhouse.svg" alt="..." />
                    </router-link>
                  </li>
                  <li v-if="isNotInHome()">
                    <a href="#" @click.prevent="logout" class="logOut">
                      <span class="material-icons icon-image-preview">exit_to_app</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="headerRightLink d-flex align-items-center" v-if="mounted">
                <div v-if="!$store.state.chat.connected">
                  <button class="nav-link btn btn-disabled">{{ $t('main.offline_status') }}</button>
                </div>
                <div class="d-flex align-items-center" v-else>
                  <div v-if="!stopped">
                    <button
                      @click.prevent="emergencyStop"
                      type="button"
                      class="btn btn-sm btn-outline-danger d-flex align-items-center"
                    >
                      <span class="material-icons material-icons-outlined mr-1">warning</span>
                      <span class="textCol">{{ $t('main.emergency') }}</span>
                    </button>
                  </div>
                  <div v-else>
                    <button
                      @click.prevent="emergencyStop"
                      type="button"
                      class="btn btn-sm btn-outline-success d-flex align-items-center"
                    >
                      <span class="material-icons material-icons-outlined mr-1">warning</span>
                      <span class="textCol">{{ $t('main.release') }}</span>
                    </button>
                  </div>
                  <div class="pl-3">
                    <router-link class="btn-link text-dark d-block" to="/">
                      <span
                        style="line-height:inherit;"
                        class="material-icons material-icons-sharp"
                      >agriculture</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GuiError />
      <div class="pageContent h-100">
        <div class="container h-100">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";

import RosService from "@/services/RosService.js";
import GuiError from "@/components/GuiError.vue";

export default {
  name: "Home",
  data() {
    return {
      stopped: false,
      mounted: false
    };
  },
  components: {
    GuiError
  },
  computed: mapState({
    loggedIn: state => state.loggedIn,
    routeName: state => state.route.name
  }),
  mounted() {
    this.mounted = true;
  },
  methods: {
    emergencyStop() {
      this.stopped = !this.stopped;
      RosService.emergency(this.stopped);
    },
    logout() {
      this.$store.dispatch("login", null);
      this.$router.push("Login");
    },
    isNotInHome() {
      return this.$router.history.current["path"] == "/";
    },
    isNotInLogin() {
      return this.$router.history.current["path"] == "/login";
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>


<style>
@media (min-width: 800px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 800px !important;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f1f4f6;
  min-height: 400px;
  color: #2c3e50;
  height: 100vh;
  /* max-width: 400px; */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

.title {
  font-size: 20px;
}
</style>